const state = {
  searchState: false,
  dialog: {
    active: false,
    date: new Date(),
    data: {},
  },
  helperState: false
}

const getters = {
  
}

const mutations = {
  SET_SEARCH_STATE (state, payload) {
    state.searchState = payload
  },
  SET_HELPER_STATE (state, payload) {
    state.searchState = payload
  },
  TRIGGER_DIALOG (state, payload){
    state.dialog.data = payload.data
    state.dialog.date = new Date()
    state.dialog.active = true
  },
  CLEAR_DIALOG (state) {
    state.dialog.data = {}
    state.dialog.active = false
  },
}

const actions = {

}

export default {
  state,
  getters,
  mutations,
  actions
}